module.exports = __webpack_public_path__ + "static/assets/c9c23c3fb536dfe0fd6da1f4aa1b8518.jpg";